<template>

  <div class="item_main">

    <div class="title">1.加入单词本</div>
    <div class="content">在背单词页面，通过左右滑动，点击相应按钮，可将单词加入生词、熟知词或自定义释义。单词本中单词也可通过左右滑动实现不同功能。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/wordbook.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>


    <div class="title">2.生词</div>
    <div class="content">该选项卡包含所有加入的生词，可左右滑动实现删除、编辑释义等功能，也可长按查词。点击添加生词按钮，可直接添加生词。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/addNewWord.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="title">3.熟知词</div>
    <div class="content">该选项卡包含所有加入的熟知词，可左右滑动实现删除、编辑释义等功能，也可长按查词。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/knownword.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="title">4.自定义释义</div>
    <div class="content">该选项卡包含所有加入的自定义释义，可左右滑动实现删除、编辑释义等功能，也可长按查词。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/custommean.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>

    <div class="title">5.学习进度</div>
    <div class="content">该选项卡包含在学词书的学习进度，可左右滑动实现删除、编辑释义等功能，也可长按查词。
  
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/usage/studyprogress.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>







    </div>
  

  
 



  
  

  
    
  </template>
  
  <script setup>

  </script>
  
  <style scoped>

  .item_main {
    font-size: 0.4rem;
    margin-left: 0.4rem;
    margin-right: 0.4rem;
    text-align: left;
  }

  .title {
    font-size: 0.45rem;
    font-weight: bold;
    margin-top: 0.4rem;
    margin-bottom: 0.2rem;
  }
  .second_title {
    font-size: 0.42rem;
    
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }

  .content {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }

  .image-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  
  </style>